/**
 * English unit-rate vocabulary and template (ADR 0051 part 3). Unchanged
 * from the original inline text and RATE_PAIRS table.
 *
 * `perPlural` is written out rather than built by appending "s" at runtime -
 * ADR 0051 §5's "pre-agreed, no runtime inflection" rule applied to the one
 * place this format pluralises a unit.
 */
export const ratePairs: Array<{ of: string; per: string; perPlural: string }> = [
    { of: 'miles', per: 'hour', perPlural: 'hours' },
    { of: 'words', per: 'minute', perPlural: 'minutes' },
    { of: 'dollars', per: 'item', perPlural: 'items' },
    { of: 'pages', per: 'day', perPlural: 'days' },
    { of: 'litres', per: 'minute', perPlural: 'minutes' },
    { of: 'points', per: 'game', perPlural: 'games' },
];

export const ratioPrompts = {
    unitRate: (total: number, of: string, units: number, perPlural: string, per: string) =>
        `${total} ${of} in ${units} ${perPlural} = ______ ${of} per ${per}`,
    /** ADR 0104 §2: the three table questions and the two answers of the first. */
    proportionalYesNo: () =>
        `Is y proportional to x? If it is, give the constant of proportionality.`,
    proportionalConstant: () =>
        `Find the constant of proportionality, then write an equation for y.`,
    proportionalFill: () => `y is proportional to x. Fill in the table.`,
    proportionalYes: (constant: number) => `Yes, k = ${constant}`,
    proportionalNo: () => `No`,
    /** ADR 0105 §2: the graph question that reads past the edge of the grid. */
    proportionalBeyond: (x: number) => `Use the graph to find y when x = ${x}.`,
};
